<template>
  <div id="dashboard" class="content">
    <div class="block block-rounded block-bordered">
      <!-- <div class="block-header block-header-default">
        <h3 class="block-title">白名单用户管理</h3>
        <div class="block-options">
          <button
            v-if="addBtn"
            type="button"
            class="btn-block-option add-btn mr-2"
            data-toggle="modal"
            @click="create(true, {})"
          >
            <i class="fa fa-plus mr-1"></i> 新增
          </button>
          <button
            type="button"
            class="btn-block-option"
            data-toggle="block-option"
            data-action="fullscreen_toggle"
          >
            <i class="si si-size-fullscreen"></i>
          </button>
        </div>
      </div>-->
      <div class="block-content block-content-full">
        <div class="dataTables_wrapper dt-bootstrap4 no-footer">
          <div class="row mb-1">
            <div class="col-12 col-md-4 text-center text-md-left">
              <pageSize @changePageSize="changePageSize"></pageSize>
            </div>
            <div class="col-12 col-md-4 text-center text-md-center" v-show="!isMobile">
              <div class="dt-buttons">
                <button
                  class="dt-button buttons-copy buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                  tabindex="0"
                  aria-controls="DataTables_Table_1"
                  data-clipboard-text
                  @click="copy()"
                  type="button"
                  id="copybtn"
                >
                  <span>复制</span>
                </button>
                <button
                  class="dt-button buttons-csv buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                  @click="exportCSV()"
                  type="button"
                >
                  <span>导出</span>
                </button>
                <button
                  class="dt-button buttons-print btn btn-sm btn-primary mr-2 pding-btn"
                  @click="print()"
                >
                  <span>打印</span>
                </button>
              </div>
            </div>
            <div class="col-12 col-md-4 text-center text-md-right">
              <div class="dataTables_filter">
                <label>
                  <input
                    type="search"
                    class="form-control"
                    placeholder="搜索"
                    v-model="key"
                    @keyup.enter="search()"
                  />
                </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="table-responsive">
                <section ref="print">
                  <p class="show-on-print print-title">白名单用户</p>
                  <table
                    class="table table-bordered table-striped table-vcenter js-dataTable-full dataTable no-footer"
                  >
                    <thead>
                      <tr>
                        <th
                          class="text-center sorting"
                          @click="getList('ID',$event)"
                          style="width: 60px; min-width:60px"
                        >#</th>
                        <th
                          class="text-left sorting"
                          @click="getList('USER_ID',$event)"
                          style="min-width:85px;"
                        >用户ID</th>
                        <th
                          class="text-left sorting"
                          @click="getList('MOBILE_PHONE',$event)"
                          style="min-width:85px;"
                        >手机号码</th>
                        <th
                          class="text-left sorting"
                          @click="getList('CARD_NO',$event)"
                          style="min-width:85px;"
                        >实体卡号</th>
                        <th
                          class="text-left sorting"
                          @click="getList('CELL_NAME',$event)"
                          style="min-width:100px;"
                        >小区名称</th>
                        <th
                          class="text-left sorting d-md-table-cell"
                          @click="getList('LIMIT_DURATION',$event)"
                          style="min-width:125px;"
                        >每日限制时长</th>
                        <th
                          class="text-left sorting d-xl-table-cell"
                          @click="getList('RESET_HOUR',$event)"
                          style="min-width:130px;"
                        >每日重置时间</th>
                        <th
                          class="text-left sorting d-xl-table-cell"
                          @click="getList('START_EFFECTIVE_TIME',$event)"
                          style="min-width:110px;"
                        >生效日期</th>
                        <th
                          class="text-lef sorting"
                          @click="getList('EXPIRED_TIME',$event)"
                          style="min-width: 110px;"
                        >失效日期</th>
                        <th
                          class="text-center d-xl-table-cell sorting"
                          style="width: 110px; min-width:110px"
                          @click="getList('IS_EFFICTIVE',$event)"
                        >白名单状态</th>
                        <th
                          class="text-center d-xl-table-cell sorting"
                          style="width: 100px; min-width:100px"
                          @click="getList('STATE',$event)"
                        >用户状态</th>
                        <th
                          class="text-center no-print"
                          style="width: 100px;min-width: 100px;"
                          v-if="editBtn || delBtn"
                        >操作</th>
                      </tr>
                    </thead>
                    <tbody v-if="agents.length">
                      <tr v-for="(agent, i) in agents" :key="i">
                        <td class="text-center">{{ i + 1 }}</td>
                        <td class="text-left">{{ agent.USER_ID }}</td>
                        <td class="text-left">{{agent.MOBILE_PHONE}}</td>
                        <td class="text-left">{{agent.CARD_NO}}</td>
                        <td class="text-left">{{ agent.CELL_NAME }}</td>
                        <td class="text-left d-md-table-cell">{{ agent.LIMIT_DURATION }}小时</td>
                        <td class="text-left">{{agent.RESET_HOUR}}</td>
                        <td class="text-left d-xl-table-cell">{{ agent.START_EFFECTIVE_TIME }}</td>
                        <td
                          class="text-left d-xl-table-cell"
                          style="min-width:80px;"
                        >{{ agent.EXPIRED_TIME }}</td>
                        <td class="text-center">
                          <span
                            class="badge badge-pill"
                            :class="{'badge-success':agent.IS_EFFICTIVE=='1','badge-secondary':agent.IS_EFFICTIVE=='0','badge-warning':agent.IS_EFFICTIVE=='2'}"
                          >{{showEffictive(agent.IS_EFFICTIVE)}}</span>
                        </td>
                        <td class="text-center">
                          <div class="custom-control custom-switch custom-control-primary">
                            <input
                              type="checkbox"
                              class="custom-control-input"
                              name="example-sw-primary2"
                              :checked="agent.STATE == 2 ? false : true"
                              disabled
                            />
                            <label
                              class="custom-control-label"
                              :for="'dexample-sw-custom-success-state' + agent.ROWNUM"
                            ></label>
                          </div>
                        </td>

                        <td class="text-center no-print" v-if="editBtn || delBtn">
                          <div class="btn-group">
                            <button
                              v-if="editBtn"
                              type="button"
                              class="btn btn-primary js-tooltip-enabled"
                              data-toggle="modal"
                              title="编辑"
                              @click="$router.push({name:'carportWhiteUser', params:{id:agent.USER_ID,val:key,type:'white'}})"
                              data-original-title="Edit"
                            >
                              <i class="fa fa-pencil-alt"></i>
                            </button>
                            <button
                              v-if="delBtn"
                              type="button"
                              class="btn btn-primary js-tooltip-enabled"
                              data-toggle="tooltip"
                              title="删除"
                              @click="delUser(agent)"
                              data-original-title="Edit"
                            >
                              <i class="fa fa-times"></i>
                            </button>
                            <!-- <button
                              v-if="stateBtn"
                              type="button"
                              class="btn btn-primary js-tooltip-enabled"
                              data-toggle="tooltip"
                              title="修改状态"
                              @click="createSet(agent)"
                              data-original-title="Edit"
                            >
                              <i class="fa fa-user-cog"></i>
                            </button>-->
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td class="text-center" colspan="12">查无数据</td>
                      </tr>
                    </tbody>
                  </table>
                </section>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-5 text-center text-md-left" v-show="!isMobile">
              <div class="dataTables_info" role="status" aria-live="polite">
                页数
                <strong>{{ page }}</strong> /
                <strong>{{ totalPage }}</strong>
              </div>
            </div>
            <div class="col-sm-12 col-md-7 text-center text-md-right">
              <div class="dataTables_paginate paging_full_numbers">
                <el-pagination
                  v-if="agents && agents.length"
                  @current-change="handleCurrentChange"
                  :current-page="page"
                  :page-size="pageSize"
                  :small="isMobile"
                  :pager-count="pagerCount"
                  :layout="isMobile ? 'prev, pager, next':'total, prev, pager, next'"
                  :total="total"
                  background
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="modal-default-normal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-default-normal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{created ? '新增白名单用户' : '白名单用户信息'}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body pb-1">
            <form class="form-horizontal">
              <div class="form-group form-group-50" v-show="created">
                <label class="col-sm-12 control-label">
                  新增方式
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <select
                    class="form-control"
                    id="cell-auth-type"
                    name="cell-auth-type"
                    v-model="form.type"
                    :disabled="!created"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in addTypeList"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group" :class="{'form-group-50':created}">
                <label class="col-sm-12 control-label">
                  用户ID
                  <span class="input-required" v-show="form.type == 3">*</span>
                </label>
                <div class="col-sm-12">
                  <input
                    :disabled="!created||form.type!='3'"
                    class="form-control"
                    placeholder
                    v-model="  form.userId"
                    maxlength="30"
                  />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  手机号码
                  <span class="input-required" v-show="form.type == 1">*</span>
                </label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    v-model="  form.mobilePhone"
                    maxlength="11"
                    :disabled="created&&form.type!='1'"
                  />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  实体卡号
                  <span class="input-required" v-show="form.type == 2">*</span>
                </label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    maxlength="16"
                    v-model="form.userCard"
                    :disabled="created&&form.type!='2'"
                  />
                </div>
              </div>
              <div class="form-group">
                <label for="cell-sel" class="col-sm-5 control-label">
                  所在区域
                  <span class="input-required" v-show="created">*</span>
                </label>
                <div class="col-sm-12">
                  <select
                    class="form-control col-sm-4 form-group-b"
                    style="float:left"
                    @change="provinceSel()"
                    v-model="pro"
                    :disabled="!created"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in provinceList"
                      :key="index"
                      :value="item.DISTRICT_CODE"
                    >{{item.DISTRICT_NAME}}</option>
                  </select>
                  <select
                    class="form-control col-sm-4 form-group-b"
                    style="float:left"
                    @change="citySel()"
                    v-model="city"
                    :disabled="!created"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in cityList"
                      :key="index"
                      :value="item.DISTRICT_CODE"
                    >{{item.DISTRICT_NAME}}</option>
                  </select>
                  <select
                    class="form-control col-sm-4 form-group-b"
                    @change="disSel()"
                    v-model="dis"
                    :disabled="!created"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in districtList"
                      :key="index"
                      :value="item.DISTRICT_CODE"
                    >{{item.DISTRICT_NAME}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-12 control-label">
                  小区名称
                  <span class="input-required" v-show="created">*</span>
                </label>
                <div class="col-sm-12">
                  <select
                    class="form-control col-sm-12"
                    v-model="form.groupId"
                    :disabled="!created"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in cellList"
                      :key="index"
                      :value="item.CELL_ID"
                    >{{item.CELL_NAME}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  每日限制时长
                  <span class="input-required" v-show="created">*</span>
                </label>
                <div class="col-sm-12">
                  <select class="form-control col-sm-12" v-model="form.limitDuration">
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option v-for="(item,index) in 24" :key="index" :value="item">{{item+'小时'}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  每日重置时间
                  <span class="input-required" v-show="created">*</span>
                </label>
                <div class="col-sm-12">
                  <select class="form-control" v-model="  form.resetHour">
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in 24"
                      :key="index"
                      :value="index>9?index+':00':('0'+index + ':00')"
                    >{{index>9?index+':00':('0'+index + ':00')}}</option>
                  </select>
                </div>
              </div>

              <!-- <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  允许其它方式充电
                  <span class="input-required" v-show="created">*</span>
                </label>
                <div class="col-sm-12">
                  <select
                    class="form-control"
                    v-model="  form.allowOther"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in allowType"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>
              </div>-->
              <div class="form-group form-group-50">
                <label for="cell-auth-type" class="col-sm-12 control-label">
                  白名单生效日期
                  <span class="input-required" v-show="created">*</span>
                </label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="js-flatpickr form-control bg-white"
                    name="example-flatpickr-default"
                    v-model="  form.startEffectiveTime"
                    placeholder="请选择"
                  />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label for="cell-auth-type" class="col-sm-12 control-label">白名单失效日期</label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="js-flatpickr form-control bg-white"
                    name="example-flatpickr-default"
                    v-model="  form.expiredTime"
                    placeholder="默认无限制"
                  />
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer modal-footer-right">
            <button type="button" class="btn btn-sm btn-light btn-sm-h" data-dismiss="modal">取消</button>
            <button type="button" class="btn btn-sm btn-primary btn-sm-h" @click="submit()">保存</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Util from "../../../Util.js";
import pageSize from "../../../components/pageSize";
export default {
  name: "index",
  data() {
    return {
      agents: [],
      entry: {},
      setToday: new Date(),
      starttime: "",
      endtime: "",
      key: "",
      page: 1,
      size: 10,
      total: 1,
      pageSize: 20,
      selects: [10, 20, 30, 50],
      wehitUserGroups: [],
      billtype: [
        {
          value: 1,
          label: "免费"
        },
        {
          value: 2,
          label: "按正常收费"
        }
      ],
      allowType: [
        {
          value: 1,
          label: "是"
        },
        {
          value: 0,
          label: "否"
        }
      ],
      addTypeList: [
        {
          value: "3",
          label: "用户ID"
        },
        {
          value: "1",
          label: "手机号码"
        },
        {
          value: "2",
          label: "实体卡号"
        }
      ],
      provinceList: [],
      cityList: [],
      districtList: [],
      cellList: [],
      pro: "",
      city: "",
      dis: "",
      edit: "",
      created: false,
      form: {
        userId: "",
        groupId: "",
        mobilePhone: "",
        startEffectiveTime: "",
        expiredTime: "",
        resetHour: "",
        limitDuration: "",
        allowOther: "",
        userCard: "",
        type: ""
      },
      clipboard: null,
      sorting: "",
      orderBy: false,
      del: "",
      addBtn: Util.isHavePerm("cell/addUser"),
      editBtn: Util.isHavePerm("cell/updateUser"),
      stateBtn: Util.isHavePerm("cell/updateContraintUserState"),
      delBtn: Util.isHavePerm("cell/deleteUser")
    };
  },
  components: {
    pageSize
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    roleName() {
      return this.$store.state.roleName;
    },
    totalPage() {
      if (this.total == 0) {
        return 0;
      } else {
        return Math.ceil(this.total / this.pageSize, 1);
      }
    },
    pagerCount() {
      return this.$store.state.pagerCount;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    searchKye() {
      return this.$store.state.searchKye;
    },
    params() {
      return this.$store.state.params;
    },
    regionParams() {
      return this.$store.state.regionParams;
    }
  },
  watch: {
    "$store.state.duration": {
      handler: function(val, oldVal) {
        if (typeof oldVal === "undefined") return;
        if (JSON.stringify(val) != JSON.stringify(oldVal)) {
          this.getList();
        }
      },
      immediate: true,
      deep: true
    },
    key(val, oldVal) {
      if (val.length == 0 || this.searchKye) {
        this.getList();
      }
    },
    "form.mobilePhone"(val, oldVal) {
      this.form.mobilePhone = Util.isNumber(val);
    },
    "form.userCard"(val, oldVal) {
      this.form.userCard = Util.isNumber(val);
    },
    "form.userId"(val, oldVal) {
      this.form.userId = Util.isNumber(val);
    },
    "form.type"(val, oldVal) {
      if (val == "1") {
        this.form.userCard = "";
        this.form.userId = "";
      } else if (val == "2") {
        this.form.mobilePhone = "";
        this.form.userId = "";
      } else if (val == "3") {
        this.form.mobilePhone = "";
        this.form.userCard = "";
      }
    }
  },
  mounted() {
    if (this.params.type && this.params.type == "white" && this.params.val) {
      this.key = this.searchKye;
    }
    setTimeout(() => {
      Dashmix.helpers(["flatpickr", "datepicker"]);
    }, 1000);
    this.getList();
    this.copy();
    this.getProvince();
  },
  methods: {
    showEffictive(str) {
      switch (str) {
        case "0":
          return "失效";
        case "1":
          return "有效";
        // case "2":
        //   return "待生效";
      }
    },
    changePageSize(val) {
      this.pageSize = val;
      this.page = 1;
    },
    create(bool, item) {
      jQuery("#modal-default-normal").modal("show");
      this.pro = "";
      this.city = "";
      this.dis = "";
      if (bool) {
        this.created = true;
        this.form = {
          userId: "",
          groupId: "",
          startEffectiveTime: "",
          cellName: "",
          expiredTime: "",
          limitDuration: "",
          resetHour: "",
          mobilePhone: "",
          allowOther: "",
          userCard: "",
          type: ""
        };
      } else {
        this.created = false;
        this.form = {
          userId: item.USER_ID,
          cellName: item.CELL_NAME,
          mobilePhone: item.MOBILE_PHONE,
          startEffectiveTime: item.START_EFFECTIVE_TIME,
          expiredTime: item.EXPIRED_TIME,
          limitDuration: item.LIMIT_DURATION,
          resetHour: item.RESET_HOUR,
          allowOther: item.ALLOW_OTHER,
          groupId: item.CELL_ID,
          userCard: item.CARD_NO
        };
        Util.displayAreaCell(item.CELL_ID, this, true);
      }
    },
    showModal(id, value) {
      $(`#modify${id}`).click(_ => {
        this.created = false;
        this.form = {
          remark: value.REMARK,
          billingType: value.BILLING_TYPE == "免费" ? 1 : 2,
          groupId: value.GROUP_ID
        };
      });
    },
    submit() {
      let url = "";
      if (this.created) {
        url = `${Util.operateURL}/cell/addUser`;
      } else {
        url = `${Util.operateURL}/cell/updateUser`;
      }
      this.$http.post(url, this.form).then(
        res => {
          if (res.data.code === 200) {
            Util.message("succ", res.data.desc);
            jQuery("#modal-default-normal").modal("hide");
            this.getList();
          } else {
            Util.message("err", res.data.desc);
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    delUser(val) {
      swal("确定移除白名单用户？", {
        buttons: {
          cancel: {
            text: "取消",
            className: "btn btn-sm btn-light btn-sm-h",
            visible: true
          },
          defeat: {
            text: "确定",
            className: "btn btn-sm btn-primary btn-sm-h"
          }
        }
      }).then(value => {
        switch (value) {
          case "defeat":
            this.$http
              .post(`${Util.operateURL}/cell/deleteUser`, {
                userId: val.USER_ID,
                groupId: val.CELL_ID
              })
              .then(res => {
                if (res.data.code === 200) {
                  Util.message("succ", res.data.desc);
                  this.getList();
                } else {
                  Util.message("err", res.data.desc);
                }
              });
            break;
        }
      });
    },
    createSet(val) {
      this.cellId = val.CELL_ID;
      this.del = val.STATE == 1 ? 2 : 1;
      let text = this.del == 2 ? "确定禁用？" : "确定启用？";
      swal(text, {
        buttons: {
          cancel: {
            text: "取消",
            className: "btn btn-sm btn-light btn-sm-h",
            visible: true
          },
          defeat: {
            text: "确定",
            className: "btn btn-sm btn-primary btn-sm-h"
          }
        }
      }).then(value => {
        switch (value) {
          case "defeat":
            this.$http
              .post(`${Util.operateURL}/cell/updateContraintUserState`, {
                userId: val.USER_ID,
                state: val.STATE == 1 ? 2 : 1,
                groupId: val.CELL_ID
              })
              .then(res => {
                if (res.data.code === 200) {
                  Util.message("succ", res.data.desc);
                  this.getList();
                } else {
                  Util.message("err", res.data.desc);
                }
              });
            break;
        }
      });
    },
    selectVal(ele) {
      this.selected = ele.target.value;
    },

    getList(sorting, that) {
      let params = {};
      if (this.key.length > 0) {
        params["key"] = this.key.trim();
      }

      if (sorting != undefined || this.sorting.length > 0) {
        this.sorting = sorting == undefined ? this.sorting : sorting;
        params["sort"] = this.sorting;
        params["orderBy"] = this.orderBy;

        if (that != undefined && that.currentTarget != undefined) {
          var obj = that.currentTarget;
          if (
            $(obj).is(".sorting_asc") ||
            $(obj).is(".sorting_desc") ||
            $(obj).is(".sorting")
          ) {
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_asc");
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_desc");
            $(obj).addClass(this.orderBy ? "sorting_asc" : "sorting_desc");
            this.orderBy = !this.orderBy;
            params["orderBy"] = this.orderBy;
          }
        }
      }

      this.$http
        .get(
          `${Util.searchURL}/Carport/ListByChargeWhite/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}`,
          {
            params: params
          }
        )
        .then(res => {
          if (res.data.code === 200) {
            this.agents = res.data.data.data;
            this.total = res.data.data.pageInfo.total;
          }
        });
    },
    getProvince() {
      this.$http.get(`${Util.searchURL}/Province/ListByCarportAll`).then(
        res => {
          if (res.data.code === 200) {
            this.provinceList = res.data.data;
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    provinceSel() {
      this.$http
        .get(`${Util.searchURL}/City/ListByCarportProvince/${this.pro}`)
        .then(
          res => {
            if (res.data.code === 200) {
              this.cityList = res.data.data;
              this.city = "";
              this.districtList = [];
              this.dis = "";
              this.cellList = [];
              this.form.groupId = "";
            }
          },
          err => {
            console.log(err);
          }
        );
    },
    citySel() {
      this.$http
        .get(`${Util.searchURL}/District/ListByCarportCity/${this.city}`)
        .then(
          res => {
            if (res.data.code === 200) {
              this.districtList = res.data.data;
              this.dis = "";
              this.cellList = [];
              this.form.groupId = "";
            }
          },
          err => {
            console.log(err);
          }
        );
    },
    disSel() {
      this.$http
        .get(`${Util.searchURL}/FlatComplex/ListByCarportDistrict/${this.dis}`)
        .then(
          res => {
            if (res.data.code === 200) {
              this.cellList = res.data.data;
              this.form.groupId = "";
            }
          },
          err => {
            console.log(err);
          }
        );
    },
    exportCSV() {
      let params = {};
      if (this.key) {
        params["key"] = this.key.trim();
      }
      // params['key'] =  ''
      params["down"] = 1;
      params["sort"] = this.sorting;
      params["orderBy"] = this.orderBy;
      this.$http
        .get(
          `${Util.searchURL}/Carport/ListByChargeWhite/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}`,
          {
            params: params,
            responseType: "blob"
          }
        )
        .then(res => {
          if (res.status === 200) {
            Util.ExportCSV(res);
          }
        });
    },
    print() {
      this.$print(this.$refs.print);
    },
    copy() {
      let copyStr = document.getElementsByTagName("section")[0].innerText;
      var btn = document.getElementById("copybtn");
      btn.setAttribute("data-clipboard-text", copyStr);
      this.clipboard = new ClipboardJS(btn);
      this.clipboard.on("success", e => {
        Util.message("succ", "复制成功");
        this.clipboard.destroy();
        e.clearSelection();
      });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    search() {
      this.page = 1;
      this.getList();
    }
  }
};
</script>